import totalesGetters from "./Cuentas/TotalesGetters";
import axios from "axios";

export default {
  state: () => ({
    cuentas: [],
  }),
  mutations: {
    setCuentas(state, payload) {
      state.cuentas = payload;
    },
  },
  actions: {
    async getCuentas(context) {
      try {
        let resp = await axios.get("/cuentas");
        context.commit("setCuentas", resp.data);
      } catch (e) {
        Promise.reject(e);
      }
    },
    async makeTransaction(context, fd) {
      try {
        let resp = await axios.post("/cuentas", fd);
        if (resp.data.ok) {
          await context.dispatch("getCuentas");
          return resp.data.message;
        }
      } catch (e) {
        console.log(e);
      }
    },
  },
  getters: {
    ...totalesGetters,
    getCuentasEfectivo(state) {
      try {
        return state.cuentas.efectivo;
      } catch (e) {
        return [];
      }
    },
    getCuentasCheques(state) {
      try {
        return state.cuentas.cheques;
      } catch (e) {
        return [];
      }
    },
  },
};
